"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDictionary = void 0;
const ramda_1 = require("ramda");
/**
 * Filter dictionary keys using a predicate
 * @public
 *
 * @param predicate - The function to be applied to every key in the dictionary (Root level only)
 * @param input - The dictionary to be filtered
 *
 * @returns A subset of the input object
 *
 * @example
 * ```ts
 * const config = {
 *   key: 'value',
 *   key2: 'value2',
 * }
 * const result = filterDictionary(
 * (value, key) => key === 'key',
 * config
 * );
 * console.log(result);
 * // -> { key: 'value' }
 * ```
 */
function filterDictionary(predicate, input) {
    return (0, ramda_1.pickBy)(predicate, input);
}
exports.filterDictionary = filterDictionary;
//# sourceMappingURL=filter-dictionary.js.map